<div class="center-xs custom_modal">
  <div class="modal-head" [innerHTML]="'SHARED.MODAL.HEADER_SUCCESS' | translate: data" [ngClass]="data.type"></div>

  <div class="modal-body" [innerHTML]="'SHARED.MODAL.MSG_SUCCESS' | translate: data"></div>

  <div class="modal-buttons">
    <a (click)="gotoOverviewAndClose()" class="default" mat-button buttonClickOnEnter [is-modal]="true" aria-disabled="false" tabindex="0"
      ><i class="fa fa-plus-square-o" aria-hidden="true"></i> {{ 'SHARED.BUTTONS.GO_TO_OVERVIEW' | translate }}</a
    >
    <a (click)="gotoDetailAndClose()" class="default" mat-button buttonClickOnEnter [is-modal]="true" aria-disabled="false" tabindex="0"
      ><i class="fa fa-plus-square-o" aria-hidden="true"></i> {{ 'SHARED.BUTTONS.GO_TO_DETAIL' | translate }}</a
    >
    <a (click)="gotoCreateAndClose()" class="default" mat-button buttonClickOnEnter [is-modal]="true" aria-disabled="false" tabindex="0"
      ><i class="fa fa-plus-square-o" aria-hidden="true"></i> {{ 'SHARED.BUTTONS.CREATE_A_NEW_ONE' | translate }}</a
    >
  </div>
</div>
